const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./customer-fullcont-handler')

export function start(detail) {
    if (obj[detail.act]) {
        obj[detail.act].start(detail)
    }
}

const obj = {
    load:       { start: (detail) => { load(detail)         } },
    submit:     { start: (detail) => { submit(detail)       } },
    typing:     { start: (detail) => { typing(detail)       } },
    beforeChat: { start: (detail) => { beforeChat(detail)   } },
}

const CUSTOMER_QUESTIONS = [
    "Total sold to the customer?",
    "Outstanding balance?",
    "Sales summary to the customer?",
]

function getGeneralQuestions(type) {
    if (type === "customer") {
        return CUSTOMER_QUESTIONS
    }
}

function load(detail) {

    const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
    const recordId = fullcontActivo.getAttribute('data-dbid')

    const cardWarning = `
        <div class="row">
            <div class="c33">
                <div class="chat-type-text">
                    Entity: ${detail.dest}
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    Type: Customer
                </div>
            </div>

            <div class="c33">
                <div class="chat-type-text">
                    ID: ${recordId}
                </div>
            </div>
        </div>

        <div class="row mt-8">
            <div class="c100">
                <div class="chat-type-text">
                    This chat is limited to this entity and to the history of this customer
                </div>
            </div>
        </div>
    `;

    if (recordId) {
        chat.start(
            {
                "dest": "chat",
                "act": "quickview",
                "actQuickview": "show",
                "type": "customer",
                "entity": "customer",
                "question": detail.question ?? "",
                "generalQuestions": getGeneralQuestions("customer"),
                "recordId": recordId,
                "ev": detail.ev,
                "cardWarning": cardWarning,
            }
        )

        const msj = handler.getChatsFc();
        chat.start({
            "dest": "chat",
            "act": "load",
            "chats": msj,
            "generalQuestions": getGeneralQuestions("customer"),
            "cardWarning": cardWarning,
        })
    }

}

function typing(detail) {
    chatHandler.typing(detail)
}